import {Pipe, PipeTransform} from '@angular/core';
import {EventItem, League} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import dayjs from "dayjs";

@Pipe({
  name: 'leagueRound'
})
export class LeagueRoundPipe implements PipeTransform {

  constructor(private translocoService:TranslocoService) {
  }

  transform(eventItem?: EventItem, legaue?:League): string {
    var round:number = 0;
    if (legaue && eventItem) {
      let sortedEvents: EventItem[] = this.sortEvents(legaue);
      var index: number = sortedEvents.indexOf(eventItem);
      if (index !== -1) {
        round = index;
      }
    }
    /// index starts from 0
    round = round +1;
    return this.translocoService.translate("league.round", {value:round});
  }

  private sortEvents(league:League): EventItem[] {
    let events: EventItem[]=[...(league?.events ?? [])];
      events.sort((eventItem1:EventItem, eventItem2:EventItem)=>{
        return dayjs(eventItem1.start!).toDate().getTime() - dayjs(eventItem2!.start!).toDate().getTime();
      });
      return events;
  }
}
